import React from 'react';

import type { ValueChangeDetails } from 'node_modules/@chakra-ui/react/dist/types/components/tabs/namespace';
import type { TabItem } from 'toolkit/components/AdaptiveTabs/types';

import { TabsRoot } from 'toolkit/chakra/tabs';
import AdaptiveTabsList from 'toolkit/components/AdaptiveTabs/AdaptiveTabsList';

interface TabOption {
  label: string;
  value: string;
}

interface Props {
  collection: Array<TabOption>;
  initialValue?: string;
  isLoading?: boolean;
  onChange: (detail: ValueChangeDetails) => void;
}

export function TabsSelect({ collection, onChange, initialValue }: Props) {

  const tabOptions: Array<TabItem> = collection?.map(item => ({
    id: item.value,
    title: item.label,
    component: null,
  }));

  return (
    <TabsRoot
      position="relative"
      onValueChange={ onChange }
      defaultValue={ initialValue }
    >
      <AdaptiveTabsList
        rightSlotProps={{ marginLeft: 0 }}
        activeTab={ tabOptions[0]?.id as string }
        variant="outline"
        listProps={{ marginBottom: 0 }}
        tabs={ tabOptions }
      />
    </TabsRoot>
  );
}
